export const ComingSoon = () => {
  return (
    <div className="w-full h-full content-center bg-blue py-32 overflow-hidden">
      <div className="flex flex-col justify-center items-center">
        <img src="/assets/logo-only.svg" alt="logo" className="h-100" />
        <p className="text-primary  opacity-50 font-bold text-3xl mt-2">Coming soon</p>

        <div className="py-3 text-center text-base text-primary opacity-50 mt-6">
          <p className="font-semibold ">大会がまだありません。</p>
          <p className="font-semibold ">公開まで今しばらくお待ちください。</p>
        </div>
      </div>
    </div>
  );
};

export default ComingSoon;
